import { App } from 'vue'

import button from './button'
import opacity from './opacity'
import scroll from './scroll'
import dragger from './dragger'
import scrub from './scrub'
import dnd from './dnd'
import component from './component'

export default {
  install(app: App) {
    button.install(app, {})
    dragger.install(app, {})
    dnd.install(app, {})
    component.install(app, {})
    opacity.install(app, {})
    scroll.install(app, {})
    scrub.install(app, {})
  },
}
